import { render, staticRenderFns } from "./AddFeed.vue?vue&type=template&id=21d9bd0f&scoped=true&"
import script from "./AddFeed.vue?vue&type=script&lang=js&"
export * from "./AddFeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21d9bd0f",
  null
  
)

export default component.exports